<template>
  <div class="d-inline-block">
  <AppHeaderDropdown right no-caret class="mr-4">
    <template slot="header" v-if="$store.getters.getUser">
      <span class="d-md-down-none">{{ $store.getters.getUser.name }}</span> 
      <span class="d-sm-block d-md-block d-lg-none d-xl-none mr-2"> <i class="fa fa-user"></i> </span>
      <i class="icon-arrow-down ml-2"></i>

      <span v-if="$store.getters.getCurrentProject !== null"></span>
    </template>
    <template slot="dropdown" >
      <b-dropdown-header tag="div" class="text-center d-sm-block d-md-block d-lg-none d-xl-none"><strong v-if="$store.getters.getUser"> {{ $store.getters.getUser.name }} </strong></b-dropdown-header>
      <b-dropdown-header tag="div" class="text-center"><strong>Platform</strong></b-dropdown-header>
      <b-dropdown-item exact :to="'/support'"><i class="bi bi-life-preserver" /> {{ $t('integrations.support.navLabel') }}</b-dropdown-item>
      <b-dropdown-item exact :to="`/admin/dashboard`" v-if="$can('dashboard access')"><i class="fa fa-desktop" /> {{ $t('dashboard') }} </b-dropdown-item>
      <b-dropdown-item exact :to="`/admin/marketplace`" v-if="$isAdmin()"><i class="cui-cart" /> {{ $t('marketplace.title') }} </b-dropdown-item>
      <b-dropdown-item exact :to="`/?force=true`"> <b-icon icon="toggle-on" scale="0.8" style="margin-right:10px;margin-left:-7px"/> {{ $t('changeProject') }} </b-dropdown-item>
      <b-dropdown-item exact :to="`/admin/projects/settings#usage`" v-if="$isAdmin() && account && account.pay_as_you_go"><i class="fa fa-database" /> {{ $t('usage') }} </b-dropdown-item>
      <b-dropdown-item @click="openConsole"><i class="bi bi-terminal" /> {{ $t('console.menuItem') }} <br />
        <small class="ml-4" style="font-size: 0.6rem; opacity: 0.7;">Ctrl+Shift+K</small>
      </b-dropdown-item>
      <b-dropdown-item @click="goToDocs"><i class="fa fa-question" /> {{ $t('tutorials.title') }}
      </b-dropdown-item>
      <b-dropdown-header
        tag="div"
        class="text-center">
        <strong>{{ $t('settings.title') }}</strong>
      </b-dropdown-header>
      <!-- Theme toggle temporarily hidden
      <b-dropdown-item @click="toggleTheme">
        <i :class="currentTheme === 'dark' ? 'fa fa-sun-o' : 'fa fa-moon-o'"></i>
        {{ currentTheme === 'dark' ? $t('lightMode') : $t('darkMode') }}
      </b-dropdown-item>
      -->
      <b-dropdown-item exact :to="`/users/profile`"><i class="fa fa-user" />{{ $t('profile') }}</b-dropdown-item>
      <b-dropdown-item exact to="/admin/projects/settings#account" v-if="$isAdmin()"><i class="fa fa-credit-card" />{{ $t('account') }}</b-dropdown-item>
      <b-dropdown-item v-if="$isAdmin() && creditBalance !== null" @click="openTopupDialog">
        <div class="d-flex align-items-center" style="min-width:0">
          <i class="bi bi-coin flex-shrink-0 mr-2" />
          <span style="min-width:0">
            <strong class="text-success text-nowrap">{{ formattedBalance }}</strong>
            <small class="d-block text-muted" style="font-size:0.7rem">{{ $t('creditTopup.headerManageLink') }}</small>
          </span>
        </div>
      </b-dropdown-item>
      <b-dropdown-item @click="showRedeemModal = true"><i class="bi bi-key" /> {{ $t('redeemCode.menuItem') }}</b-dropdown-item>
      <b-dropdown-item exact to="/admin/projects/settings"><i class="fa fa-wrench"/>{{ $t('settings.title') }}</b-dropdown-item>
      <b-dropdown-item exact :to="`/admin/components`" v-if="components.length > 0 && $can('manage base_components')"><i class="fa fa-tasks" />{{ $t('components') }}
        <b-badge variant="primary">{{ components.length }}</b-badge>
      </b-dropdown-item>

      <b-dropdown-divider />
      <b-dropdown-item v-on:click="logout()"><i class="fa fa-lock" />{{ $t('logout') }}</b-dropdown-item>
    </template>
  </AppHeaderDropdown>
  <RedeemCodeModal :show="showRedeemModal" @close="showRedeemModal = false" @redeemed="onCodeRedeemed" />
  </div>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
import RedeemCodeModal from '@/components/RedeemCodeModal.vue'

export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown,
    RedeemCodeModal,
  },
  data: () => {
    return {
      itemsCount: 0,
      projectInfo: null,
      components: [],
      showTutorial: false,
      currentTheme: 'dark',
      creditBalance: null,
      creditBalanceDisplay: null,
      billingCurrency: 'USD',
      exchangeRate: 1,
      topupBonus: 10,
      showRedeemModal: false
    }
  },
  computed: {
    formattedBalance() {
      if (this.creditBalanceDisplay === null) return null
      try {
        return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: this.billingCurrency,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(this.creditBalanceDisplay)
      } catch (e) {
        return this.creditBalanceDisplay.toFixed(2) + ' ' + this.billingCurrency
      }
    },

    projects() {
      return this.$store.getters.projects
    },

    widgets() {
      return this.$store.getters.widgets
    },

    docsUrl() {
      return this.$env.get('DOCS_URL')
    },

    workspace() {
      return this.$store.getters.getCurrentWorkspace
    },

    account() {
      return this.$store.getters.getAccount
    }
  },
  methods: {
    logout() {
      this.$http.post("/v1/user/logout").then(() => {
        this.$router.push('/login')
      }).catch(() => {
        this.$router.push('/login')
      })
    },

    goToDocs() {
      this.$store.commit("START_TUTORIAL", "introduction")
      this.$store.commit("SET_VIEW_MORE_TUTORIALS", true)
    },

    toggleTheme() {
      const newTheme = this.currentTheme === 'dark' ? 'light' : 'dark'
      this.currentTheme = newTheme
      this.$setTheme(newTheme)
    },

    openTopupDialog() {
      var exchangeRate = this.exchangeRate || 1
      if ((!exchangeRate || exchangeRate === 1) && this.creditBalance && this.creditBalanceDisplay && this.creditBalance > 0) {
        exchangeRate = this.creditBalanceDisplay / this.creditBalance
      }
      this.$root.$emit('open-credit-topup-dialog', { currency: this.billingCurrency, topupBonus: this.topupBonus, exchangeRate: exchangeRate })
    },

    onCodeRedeemed() {
      if (this.$isAdmin()) {
        this.$transactionApi.get('/billing/balance').then(resp => {
          if (resp && resp.data) {
            this.creditBalance = resp.data.balance_usd != null ? resp.data.balance_usd : null
            this.creditBalanceDisplay = resp.data.balance_display != null ? resp.data.balance_display : this.creditBalance
          }
        }).catch(() => {})
      }
    },

    openConsole() {
      console.log('[Console] Menu item clicked')
      console.log('[Console] Store state before:', this.$store.state.console)
      this.$store.dispatch('console/open')
      console.log('[Console] Store state after:', this.$store.state.console)
    },

  },

  mounted: function() {
    // Load current theme
    this.currentTheme = this.$getTheme()

    this.$store.dispatch('setUser')

    this.$store.dispatch("fetchProjectInfo").then(data => {
      this.projectInfo = data
    }).catch(error => {
      if (error.response !== undefined) {
        if (error.response.status == 500) {
          this.$serverErrorModal(error)
          return
        }
      }
    })

    this.$store.dispatch("fetchComponents").then(data => {
      this.components = data
    }).catch(error => {
      if (error.response !== undefined) {
        if (error.response.status == 500) {
          this.$serverErrorModal(error)
          return
        }
      }

      this.$debugLog(error)
    })

    if (this.$isAdmin()) {
      this.$transactionApi.get('/billing/balance').then(resp => {
        if (resp && resp.data) {
          this.creditBalance = resp.data.balance_usd != null ? resp.data.balance_usd : null
          this.creditBalanceDisplay = resp.data.balance_display != null ? resp.data.balance_display : this.creditBalance
          if (resp.data.currency) {
            this.billingCurrency = resp.data.currency
          }
          if (resp.data.exchange_rate && resp.data.exchange_rate > 0) {
            this.exchangeRate = resp.data.exchange_rate
          }
          if (resp.data.topup_bonus != null) {
            this.topupBonus = resp.data.topup_bonus
          }
        }
      }).catch(function () {})
    }
  }
}
</script>
